'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-09-14
 */
import {Person, Organization} from 'janux-people'
import _ from 'lodash'

export function partyService (http, dateUtilService) {
	/**
	 * Convert a json object to a PartyAbstract instance.
	 * @param object
	 */
	function fromJSON (object) {
		var contact
		if (_.isNil(object)) return object

		var result = _.cloneDeep(object)

		if (result.typeName === 'PersonImpl') {
			contact = Person.fromJSON(result)
		} else if (result.typeName === 'OrganizationImpl') {
			contact = Organization.fromJSON(result)
		} else {
			// E24-37: was `console.log.error`, not a real method -- threw
			// instead of logging and returning undefined as intended.
			console.error('No implementation for typeName ' + result.typeName + ' returning undefined')
			// Let it crash.
			return undefined
		}
		contact.id = result.id
		contact.dateCreated = dateUtilService.stringToDate(result.dateCreated)
		contact.lastUpdate = dateUtilService.stringToDate(result.lastUpdate)
		return contact
	}

	/**
	 * Convert a PartyAbstract instance to a JSON object.
	 * @param object
	 */
	function toJSON (object) {
		var cloned = _.cloneDeep(object)
		var id = cloned.id
		var typeName = cloned.typeName
		var contact = cloned.toJSON()
		contact.id = id
		contact.typeName = typeName
		contact.dateCreated = object.dateCreated
		contact.lastUpdate = object.lastUpdate
		return contact
	}

	return {
		fromJSON: function (object) {
			return fromJSON(object)
		},

		toJSON: function (object) {
			return toJSON(object)
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/services/party-service.js